import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import 'src/app/components/TextExpander.scss';


class TextExpander extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      expanded: props.expanded
    };
  }

  toggle = () => {
    const { expanded } = this.state;
    const newValue = !expanded;

    this.setState({ expanded: newValue });
  };


  render() {
    const { primaryText, secondaryText } = this.props;
    const { expanded } = this.state;
    const { toggle } = this;

    const classList = classNames({
      'text-expander': true,
      'text-expander--expanded': expanded
    });

    return (
      <div styleName={ classList }>

        <div styleName="text-expander__primary-text">
          {primaryText}
          { ' ' }<button
          type="button"
          styleName="text-expander__more"
          title="Rozwiń szczegóły"
          onClick={ toggle }
        >
          Więcej
          </button>
        </div>


        <div styleName="text-expander__secondary-text">
          {secondaryText}
          { ' ' }<button
          type="button"
          styleName="text-expander__less"
          title="Zwiń szczegóły"
          onClick={ toggle }
        >
          Mniej
          </button>
        </div>

      </div>
    );
  }
}


TextExpander.propTypes = {
  primaryText: PropTypes.node.isRequired,
  secondaryText: PropTypes.PropTypes.node.isRequired,
  expanded: PropTypes.bool
};

TextExpander.defaultProps = {
  expanded: false
};

export default TextExpander;
